import { ShieldCheck } from "lucide-react";
const advantages = [{
  id: "01.",
  title: "身心障礙資格",
  description: "申請人須領有身心障礙證明（聽覺障礙），且障礙程度符合政府補助標準，我們將協助您確認最新法規要求。"
}, {
  id: "02.",
  title: "專業醫院評估",
  description: "須至健保委託之鑑定醫院，由耳鼻喉科醫師及聽力師開立三個月內之評估報告，作為申請補助的核心依據。"
}, {
  id: "03.",
  title: "補助申請時限",
  description: "助聽器補助每2~4年可申請一次，若需申請雙耳補助則須符合特定聽力損失分貝標準與專業評估建議。"
}, {
  id: "04.",
  title: "完整文件備理",
  description: "備妥身分證、印章、身心障礙證明及醫院評估報告。本中心提供全程諮詢，確保您的申請流程順暢無誤。"
}];
export default function WhyChooseUs() {
  return <section data-section-id="107771" id="補助資格說明" className="bg-background py-[120px] text-foreground">
      <div className="mx-auto max-w-[1280px] px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-start">
          
          {}
          <div className="flex flex-col lg:sticky lg:top-32">
            <div className="relative mb-8 inline-flex self-start">
              {}
              <div className="absolute -inset-4 bg-accent/40 rounded-xl blur-xl -z-10"></div>
              <div className="inline-flex items-center justify-center size-24 rounded-xl bg-card text-primary border border-border shadow-sm backdrop-blur-sm">
                <ShieldCheck className="size-12" strokeWidth={1.5} />
              </div>
            </div>
            
            <h2 className="text-4xl md:text-5xl font-bold tracking-tight text-foreground leading-tight font-sans">
              補助資格說明
            </h2>
            <p className="mt-6 text-lg text-muted-foreground max-w-md leading-relaxed font-sans">
              了解政府助聽器補助申請門檻，由本中心專業聽力師協助您完成評估流程，確保您享有應有的醫療權益。
            </p>
          </div>

          {}
          <div className="flex flex-col gap-12 lg:pt-4">
            {advantages.map((adv, i) => <div key={i} data-index={i} className="flex gap-6 md:gap-8 group bg-card/30 backdrop-blur-sm rounded-xl border border-transparent hover:border-border/50 hover:shadow-md transition-all duration-300">
                {}
                <div className="font-mono text-3xl md:text-4xl font-bold text-primary shrink-0 pt-1 opacity-90 group-hover:opacity-100 transition-opacity duration-300">
                  {adv.id}
                </div>
                
                {}
                <div className="flex flex-col gap-3">
                  <h3 className="text-xl md:text-2xl font-bold text-foreground tracking-tight font-sans">
                    {adv.title}
                  </h3>
                  <p className="text-base md:text-lg text-muted-foreground leading-relaxed font-sans">
                    {adv.description}
                  </p>
                </div>
              </div>)}
          </div>

        </div>
      </div>
    </section>;
}